module.exports = __webpack_public_path__ + "media/stack-chips.aea4389f.mp3";